import { useRouter } from 'next/compat/router';
import { usePathname, useSearchParams } from 'next/navigation';

export function useSafeAsPath() {
	const router = useRouter();
	const pathname = usePathname();
	const searchParams = useSearchParams();

	if (router?.asPath) return router.asPath;

	if (pathname) {
		const search = searchParams?.toString();
		return search ? `${pathname}?${search}` : pathname;
	}

	return '';
}
